import { render, staticRenderFns } from "./mail_config.vue?vue&type=template&id=7ecd7bdf&scoped=true"
import script from "./mail_config.vue?vue&type=script&lang=js"
export * from "./mail_config.vue?vue&type=script&lang=js"
import style0 from "./mail_config.vue?vue&type=style&index=0&id=7ecd7bdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd7bdf",
  null
  
)

export default component.exports